// Professional Auth Service - API-ready with graceful fallbacks
// Centralizes auth flows: login, register, refresh, logout
// Replace mock/delay parts with real API calls when backend is ready

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";
const STORAGE_KEY = "auth.tokens.v1";

function saveTokens(tokens) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

function loadTokens() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null;
  } catch {
    return null;
  }
}

function clearTokens() {
  localStorage.removeItem(STORAGE_KEY);
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Generic API wrapper (future replacement)
async function apiFetch(path, options = {}) {
  const url = `${BASE_URL}${path}`;
  const tokens = loadTokens();
  const headers = {
    ...(options.headers || {}),
  };
  if (tokens?.accessToken) headers["Authorization"] = `Bearer ${tokens.accessToken}`;

  // NOTE: Replace with: return fetch(url, { ...options, headers });
  // For now, we simulate a reachable endpoint.
  await delay(300);
  return new Response(JSON.stringify({ ok: true }), { status: 200 });
}

export async function login(email, password) {
  if (!email || !password) throw new Error("Credenciais inválidas.");

  // Replace this block with real API call
  // const res = await fetch(`${BASE_URL}/auth/login`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) });
  // if (!res.ok) throw new Error('Falha na autenticação');
  // const data = await res.json();

  // Mocked professional response
  await delay(500);
  const data = {
    accessToken: `mock_access_${Date.now()}`,
    refreshToken: `mock_refresh_${Date.now()}`,
    user: { id: "u1", email },
  };
  saveTokens(data);
  return data;
}

export async function registerUser(payload) {
  const { name, email, password } = payload || {};
  if (!name || !email || !password) throw new Error("Dados de cadastro incompletos.");

  // Replace with real API call
  // const res = await fetch(`${BASE_URL}/auth/register`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
  // if (!res.ok) throw new Error('Falha no cadastro');
  // const data = await res.json();

  await delay(600);
  // After register, auto-login (common pattern)
  return login(email, password);
}

export async function refreshToken() {
  const tokens = loadTokens();
  if (!tokens?.refreshToken) throw new Error("Sem refresh token.");
  // Replace with real API call
  await delay(300);
  const data = {
    accessToken: `mock_access_${Date.now()}`,
    refreshToken: tokens.refreshToken,
  };
  saveTokens({ ...tokens, ...data });
  return data;
}

export function logout() {
  clearTokens();
}

export function isAuthenticated() {
  const tokens = loadTokens();
  return Boolean(tokens?.accessToken);
}

export function getCurrentUser() {
  const tokens = loadTokens();
  return tokens?.user || null;
}

export default {
  login,
  registerUser,
  refreshToken,
  logout,
  isAuthenticated,
  getCurrentUser,
};
